//登録フロー・登録後身分証アップロード：身分証の種類を選択するcomponent /newflow5
import React, { Component } from 'react';
import Header from './header'
import Footer from './footer'
import {Link, browserHistory} from 'react-router';
import './css/signUp.css';
import ToggleDisplay from 'react-toggle-display';
import users from './store/user'

export default class signUp extends Component {

  goToRegist = (e) => {
    browserHistory.push({
      pathname:'/newflow6',
      state: { kind: e.currentTarget.dataset.kind }
    })
  }

  render() {
      return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-signUp">
        <Header parentProps={this.props} />
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-signUp">
                  <h1 className="title">Sign Up</h1>
                <ToggleDisplay if={!users.getMyUser().registComplete}>
                  <img className="step_icon" src="/img/common/step-5@2x.png" alt="" />
                </ToggleDisplay>
                  <img className="title_icon" src="/img/common/img_camera.png" alt="" />
                  <h2 className="subtitle">身分証〈表面〉を登録しよう！</h2>
                  <p>本人確認を行うためですので、情報が公開されることはありません。</p>
                  <ul>
                    <li onClick={this.goToRegist} data-kind="drivers_license">運転免許証 (裏表必須)<span className="arrow"/></li>
                    <li onClick={this.goToRegist} data-kind="health_insurance_card">健康保険証 (表必須)<span className="arrow" /></li>
                    <li onClick={this.goToRegist} data-kind="passport">パスポート (顔写真面、住所面必須)<span className="arrow" /></li>
                  </ul>
                  {/* <Link to="/newflow8" className="btn-skip">身分証登録をスキップする</Link> */}
                  {/* <p className="notification">※身分証が未登録の場合、ビギナーランクからランクアップされません。 (スキップしても会員登録後にアカウント編集から登録ができます)</p> */}
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
      )

    }
}


// WEBPACK FOOTER //
// ./src/signUp.js